import React from 'react';

import PublicOffIcon from '@mui/icons-material/PublicOff';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const CancelPublishActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <PublicOffIcon />
    </BaseActionButton>
  );
};

export default CancelPublishActionButton;
